// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Administration .nav-link.active {
  background-color: #e7e8f1;
}`, "",{"version":3,"sources":["webpack://./src/pages/administration/Administration.scss"],"names":[],"mappings":"AAEQ;EACI,yBAAA;AADZ","sourcesContent":["#Administration{\n    .nav-link{\n        &.active{\n            background-color: #e7e8f1;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
